import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState } from "react";
import { exitContext } from "./context";
import { useSelector } from "src/store";

function preventDefault(e: BeforeUnloadEvent) {
    e.preventDefault();
}

export function ExitProvider({ children }: React.PropsWithChildren) {
    const [shouldPreventUnload, setShouldPreventUnload] = useState(false);
    useLayoutEffect(() => {
        setShouldPreventUnload(shouldPreventUnload);
    }, [shouldPreventUnload]);
    const { data: clinic } = useSelector((state) => state.appointment.clinic);

    useEffect(() => {
        if (shouldPreventUnload) {
            window.addEventListener('beforeunload', preventDefault);
            return () => window.removeEventListener('beforeunload', preventDefault);
        }
    }, [shouldPreventUnload]);

    const exit = useCallback(() => {
        if (window.opener) {
            window.close();
        } else {
            window.location.href = `${import.meta.env.VITE_MYHEALTH_WEBSITE}${clinic?.url ?? ''}`;
        }
    }, [clinic?.url]);

    const value = useMemo(() => {
        return {
            exit,
            setShouldPreventUnload,
            shouldPreventUnload
        }
    }, [exit, shouldPreventUnload]);

    return <exitContext.Provider value={value}>
        {children}
    </exitContext.Provider>;

}